import React from "react";
import styled from "styled-components";
import Qrimg from "../assets/images/Sudhanshu Portfolio .jpg"; // Update the path for your QR code image

// Bank Details and QR Code Components
const BankAccountDetails = () => (
  <Section>
    <SectionHeader>Bank Transfer Payment</SectionHeader>
    <BankDetails>
      <BankDetailItem>Bank Name: State Bank of India</BankDetailItem>
      <BankDetailItem>Account Holder: Passport Services</BankDetailItem>
      <BankDetailItem>Account Number: 1234567890</BankDetailItem>
      <BankDetailItem>IFSC Code: SBIN0000123</BankDetailItem>
    </BankDetails>
    <Input type="text" placeholder="Enter Transaction ID" />
    <SubmitButton>Submit Bank Transfer</SubmitButton>
  </Section>
);

const QRCodePayment = () => (
  <Section>
    <SectionHeader>QR Code Payment</SectionHeader>
    <QRCode src={Qrimg} alt="QR Code" />
    <p style={{ textAlign: "center" }}>Scan this code to pay via UPI.</p>
    <p style={{ textAlign: "center" }}>Phone Pe Number : 7219745613</p>
  </Section>
);

// Payments Page
const Payments = () => {
  return (
    <Container>
      <Title>Payments</Title>
      {/* Existing Payment Options Section */}
      <PaymentOptions>
        <QRCodePayment />
        <BankAccountDetails />
      </PaymentOptions>

      {/* New Payment Section for Secure Payment Information */}
      <PaymentSection>
        <PaymentHeader>Trusted and Safe Payment Methods</PaymentHeader>
        <PaymentList>
          <PaymentListItem>
            We offer reliable and secure payment methods to ensure a smooth
            process for your passport application.
          </PaymentListItem>
          <PaymentListItem>
            All transactions are safe and encrypted, so you can trust us with
            your payments.
          </PaymentListItem>
          <PaymentListItem>
            If you encounter any issues, we will return your amount with no
            questions asked before you get your passport appointment.
          </PaymentListItem>
        </PaymentList>
      </PaymentSection>
    </Container>
  );
};
// Styled Components
const Container = styled.div`
  max-width: 900px;
  margin: 50px auto;
  padding: 2rem;
  background-color: #f8f9fa;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-family: "Roboto Condensed", sans-serif;
`;

const Title = styled.h1`
  text-align: center;
  color: #343a40;
  margin-bottom: 2rem;
`;

const PaymentOptions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  @media (max-width: 768px) {
    display: block;
  }
`;

const Section = styled.div`
  flex: 1;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const SectionHeader = styled.h2`
  margin-bottom: 1rem;
  color: #343a40;
`;

const QRCode = styled.img`
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  display: block;
`;

const BankDetails = styled.div`
  text-align: left;
  line-height: 1.8;
  font-size: 1rem;
`;

const BankDetailItem = styled.p`
  margin: 0.5rem 0;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin: 1rem 0;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
`;

const Button = styled.button`
  background-color: black;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #343a40;
  }
`;

const PaymentForm = styled.form`
  margin-top: 2rem;
  text-align: center;
`;

const SubmitButton = styled(Button)`
  width: 100%;
`;

// Payment Section (New Section with secure payment details)
const PaymentSection = styled.div`
  margin-top: 50px;
  padding: 20px;
  background-color: #f9f9f9; /* Light blue background */
  border-radius: 10px;
  font-family: "Roboto Condensed", sans-serif;
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const PaymentHeader = styled.h2`
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 10px;
  text-align: left;
`;

const PaymentList = styled.ol`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  padding-left: 20px; /* To indent bullet points */
  margin-bottom: 15px;
  text-align: left;
`;

const PaymentListItem = styled.li`
  margin-bottom: 10px;
`;

export default Payments;
